var React = require('react');

function Plus24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Color=Black, State=Default, Size=24x24"},React.createElement("path",{"id":"Vector","d":"M12 0v12m0 0v12m0-12h12m-12 0H0","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"})));
}

Plus24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Plus24x24;

Plus24x24.default = Plus24x24;
